import WebHttpClient from '../../httpClient/WebHttpClient';
import {RevokePersonalAccessTokenRequest} from '../../ts/ServerApi/requests/RevokePersonalAccessTokenRequest';
import * as clipboard from 'clipboard-polyfill';
import {ToasterService, ToastType} from '../../ts/services/ToasterService';
import {Messages} from '../../codegen/Localize';
import {
  ButtonType,
  DialogFooterButtonsWidget,
  DialogProps,
  DialogWidget,
  TextFieldProps,
  TextFieldWidget
} from '@tableau/widgets';
import * as React from 'react';
import {PersonalAccessToken} from '../../ts/services/PersonalAccessTokensService';
import {
  internalTextFieldStyle,
  successStyle,
  textWidgetStyle,
  warningStyle
} from '../styles/CreatePersonalAccessTokenDialogStyle';


export type CreatePersonalAccessTokenDialogProps = {
  token: PersonalAccessToken;
  dismiss: (reason?: any) => void;
};

export function discardToken(props: CreatePersonalAccessTokenDialogProps) {
  WebHttpClient.sendRequest(new RevokePersonalAccessTokenRequest({
    refreshToken : props.token.tokenSecret
  })).then(() => props.dismiss());
}

export function copyToClipboard(props: CreatePersonalAccessTokenDialogProps) {
  clipboard.writeText(props.token.tokenSecret);
  ToasterService.instance.pop({ type: ToastType.Info, text: Messages.personalAccessTokensTokenCopied() });
}

export function GetFooterContent(props: CreatePersonalAccessTokenDialogProps) {
  return (
    <>
    <DialogFooterButtonsWidget
      buttons={[
        {
          handleClick: () => {
            discardToken(props);
          },
          buttonType: ButtonType.Outline,
          children: Messages.personalAccessTokenDiscard(),
          testId: 'footer-discard',
        },
        {
          handleClick: () => {
            copyToClipboard(props);
          },
          buttonType: ButtonType.Primary,
          children: Messages.personalAccessTokenCopy(),
          testId: 'footer-copy',
        }
      ]}
      testId='footer'
    />
    </>
  );
}

const InternalTextField: React.FC<Partial<TextFieldProps> & React.HTMLAttributes<HTMLInputElement>> = props => {
  return <TextFieldWidget
    {...props}
    label={props.label || props.kind}
    style={internalTextFieldStyle}
    testId={props.testId}
    disabled={true}
  />;
};

export function GetDialogWidget(dialogProps: DialogProps, token: PersonalAccessToken) {
  return (
    <DialogWidget {...dialogProps}>
      <div className={successStyle}>
        { Messages.personalAccessTokenCreateSuccess() }
      </div>
      <div className={warningStyle}>
        { Messages.personalAccessTokenOneTimeWarning() }
      </div>
      <div className={textWidgetStyle}>
        <InternalTextField kind='outline' label={Messages.personalAccessTokenName()} testId='create-personal-access-token-token-name' defaultValue={token.tokenName}/>
        <InternalTextField kind='outline' label={Messages.personalAccessTokenSecret()} testId='create-personal-access-token-token-value' defaultValue={token.tokenSecret}/>
      </div>
    </DialogWidget>
  );
}